import helper from '@/libs/forms';

const getSexFields = () => [
  helper.radios(
    'Sex',
    'sex',
    true,
    [
      { value: 'male', name: 'Male' },
      { value: 'female', name: 'Female' },
      { value: 'not_provided', name: 'I do not wish to provide this information' },
    ],
    12,
    'bold-label',
    null,
  ),
];


export default {
  schema: { fields: getSexFields() },
  options: helper.options('demographics-sex-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/demographics/schemas/sex.js